// extracted by mini-css-extract-plugin
module.exports = {"container":"StartPage_container__3TfCE","cards":"StartPage_cards__3bQoh","icon":"StartPage_icon__Cq1Hn","content":"StartPage_content__2tHEW"};